import React, { useState } from 'react'
import { DMAutomation } from '../../types/automations/dmAutomationTypes'
import InsufficientPermissionsCTA from '../CTA/InsufficientPermissions';
import { ERROR } from '../../constants/errors';
import { POSTAPIError } from '../../types';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux-stores/store';
import AutomationInsights from './AutomationInsights';
import AddLink from './AddLink';

interface AllLinkedPostsProps {
    dmAutomations: DMAutomation[]
}

const AllLinkedPosts: React.FC<AllLinkedPostsProps> = ({ dmAutomations }) => {

    const [selectedLinkForInsights, setSelectedLinkForInsights] = useState<string | null>(null);
    const [selectedLinkForEdit, setSelectedLinkForEdit] = useState<DMAutomation | null>(null);

    const loading = useSelector((state: RootState) => state.dmAutomations.loading);


    const [APIError, setAPIError] = useState<POSTAPIError | null>(null);


    return (
        <div>
            {
                APIError && APIError.error_code === ERROR.INSUFFICIENT_PERMISSIONS && APIError.missing_permissions &&
                <div className="m-3">
                    <InsufficientPermissionsCTA missing_permissions={APIError.missing_permissions} feature={APIError.feature} />
                </div>
            }


            <div className="d-flex justify-content-between flex-column align-items-center mx-3 mb-3">
                <span className='my-3'>
                    <svg width="74" height="14" viewBox="0 0 74 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line y1="6.75012" x2="25" y2="6.75012" stroke="#737373" strokeWidth="0.5" />
                        <path d="M42.1899 7.4876C39.8965 8.1051 38.1051 9.89652 37.4876 12.1899L37.0002 14.0002L36.5128 12.1899C35.8951 9.89652 34.1037 8.1051 31.8103 7.4876L30 7.0002L31.8103 6.5128C34.1037 5.8951 35.8951 4.10367 36.5126 1.81033L37 0L37.4874 1.81033C38.1049 4.10367 39.8963 5.8951 42.1897 6.5126L44 7L42.1899 7.4876Z" fill="#737373" />
                        <line x1="49" y1="6.75012" x2="74" y2="6.75012" stroke="#737373" strokeWidth="0.5" />
                    </svg>
                </span>
                <span className="text-muted fs-14 fw-400">ALL POSTS</span>
                <span className="text-dark fs-24 fw-600">METRICS</span>
            </div>
            {
                dmAutomations.length > 0 &&
                <div className="app-card p-2 mx-3">
                    <table className="table table-hover">
                        <thead>
                            <tr className='posts-table-row align-middle'>
                                <th className='text-center'>Post</th>
                                <th className='text-center'>Status</th>
                                <th className='text-center'>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                dmAutomations.map((automation, i) => {
                                    return (
                                        <tr className='posts-table-row text-center align-middle' key={i} onClick={() => setSelectedLinkForInsights(automation.social_post.uuid)}>
                                            <td>
                                                <img src={automation.social_post.thumbnail_url} className="rounded-2 post-thumbnail-sm" alt="feed" />
                                            </td>
                                            <td>
                                                {
                                                    automation.status === 'active' &&
                                                    <span className='linked-badge-sm text-success'>Linked</span>
                                                }
                                                {
                                                    automation.status === 'inactive' &&
                                                    <span className='inactive-badge-sm text-danger'>Inactive</span>
                                                }
                                            </td>
                                            <td>
                                                <button className='rounded-sm view-insights-cta text-primary'>View Insights</button>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            }
            {
                dmAutomations.length === 0 && !loading &&
                <div className="card h-full card-style rounded-card mx-3">
                    <div className="card-body">
                        <div className="h-200px d-flex justify-content-center align-items-center text-center">
                            <div className='px-5'>
                                <h2 className="pop">You have not linked any post yet!</h2>
                            </div>
                        </div>
                    </div>
                </div>
            }
            <AutomationInsights
                isActive={!!selectedLinkForInsights}
                onClose={() => setSelectedLinkForInsights(null)}
                postId={selectedLinkForInsights}
                onError={(error) => setAPIError(error)}
                onEdit={() => {
                    console.log('e', )
                    setSelectedLinkForEdit(dmAutomations.find((automation) => automation.social_post.uuid === selectedLinkForInsights)!);
                    setSelectedLinkForInsights(null);
                }}
            />
            <AddLink
                isActive={!!selectedLinkForEdit}
                onClose={() => setSelectedLinkForEdit(null)}
                post={selectedLinkForEdit?.social_post!}
                onError={(error) => {
                    setSelectedLinkForEdit(null)
                    setAPIError(error)
                }}
                dmAutomation={selectedLinkForEdit}
            />
        </div>
    )
}

export default AllLinkedPosts